import { useQuery } from "@tanstack/react-query";
import { SPONSORSHIP_QUERY_KEYS } from "@/features/sponsorship/constants/queryKeys";
import { sponsorshipService } from "@/features/sponsorship/services/sponsorship.service";
import type { CurrentCampaignResponse } from "@/features/sponsorship/types/sponsorship.type";

export const useCurrentCampaign = () => {
  const { data, isLoading, isError } = useQuery<CurrentCampaignResponse>({
    queryKey: SPONSORSHIP_QUERY_KEYS.campaign(),
    queryFn: () => sponsorshipService.getCurrentCampaign(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  const campaign = data?.sponsorship_campaign ?? null;
  const hasCampaign = campaign !== null;
  const maxRecommendations = campaign?.max_recommendations_per_employee ?? 0;
  const activeCount = campaign?.employee_sponsorship_count ?? 0;
  const remainingRecommendations = campaign?.remaining_sponsorships ?? 0;
  const isLimitReached = hasCampaign && remainingRecommendations <= 0;

  return {
    campaign,
    hasCampaign,
    maxRecommendations,
    activeCount,
    remainingRecommendations,
    isLimitReached,
    isLoading,
    isError,
  };
};
